export default {
  settingRSVP: {}
}
